<svg
	xmlns="http://www.w3.org/2000/svg"
	focusable="false"
	width="100%"
	height="100%"
	(error)="onError()"
>
	<use [attr.xlink:href]="use"></use>
</svg>
